import React, { Component } from 'react';
import './style.scss';
import SelectField from '../../../../../helpers/Fields/SelectField';
import { connect } from 'react-redux'
import {genStatisticAnswerFile, getQuestionAnswer} from '../../../../actions';
import Spiner from '../../../../../helpers/Spiner/Spiner';
import PropTypes from 'prop-types';
import {orderBy, findIndex} from 'lodash';
import classNames from 'classnames';
import { Switch } from 'antd';
import { toastr } from 'react-redux-toastr';

class AnswerStatistic extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  state = {
    loaded: true,
    answers: [],
    show_student_name: false
  }

  async componentDidMount(){
    
    this.setState({
      loaded: false,
      answers: []
    })

    let answers = await getQuestionAnswer(this.props.session_id);

    this.setState({
      loaded: true,
      answers
    })
  }

  async UNSAFE_componentWillReceiveProps(nextProps){
    if(nextProps.session_id != this.props.session_id){
      this.setState({
        loaded: false,
        answers: []
      })
  
      let answers = await getQuestionAnswer(nextProps.session_id);
  
      this.setState({
        loaded: true,
        answers
      })
    }
  }

  dowloadStatistic = async() => {
    const {formatMessage} = this.context;
    this.setState({
      loaded: false
    })
    const res = await genStatisticAnswerFile(this.props.session_id);
    console.log('resd', res);
    this.setState({
      loaded: true
    })
    if(res.status){
        window.open('/media/' + res.fileName, '_blank');
    } else {
      toastr.error(formatMessage('errTitleDowloadStatistic'), formatMessage('errMsgDowloadStatistic'))
    }
  }

  onChange = async (id) => {
    this.setState({
      loaded: false,
      answers: []
    })

    let answers = await getQuestionAnswer(id);

    this.setState({
      loaded: true,
      answers
    })
  }

  render() {
    const {formatMessage} = this.context;

    const {sessions, questions} = this.props;
    const {answers, loaded, show_student_name} = this.state;

    let tmp_item = questions.map(item => ({
      ...item, 
      order_x: isNaN(parseInt(item.order_x)) ? 0 : parseInt(item.order_x)
    }))

    const arrayChar = {
      answer_1: 'A', 
      answer_2: 'B', 
      answer_3: 'C', 
      answer_4: 'D', 
      answer_5: 'E', 
      answer_6: 'F', 
      answer_7: 'G', 
      answer_8: 'H', 
      answer_9: 'I', 
      answer_10: 'J', 
    };
  
    let items = orderBy(tmp_item, ['order_x'], ['asc']);


    const data = [];

    let students = [];

    answers.forEach(item => {
      if(findIndex(students, ['id', item.student_id]) < 0){
        students.push({id: item.student_id, answer_count: 0, student_name: item.student_name || ''});
      }
    });

    items.forEach((item, index) => {

      if(item.type == 'question'){

        let tmp_data = {
          question: item,
          number: index + 1,
          answers: []
        };

        students.forEach((user_id, index) => {
          let answer= {value: '-', is_true: null};

          answers.some(i_a => {
            if(i_a.student_id == user_id.id && i_a.question_id == item.src){

              if(i_a.answer){
                answer= {
                  value: arrayChar[i_a.answer], 
                  is_true: i_a.is_true 
                };
              } else if(i_a.answer == '') {
                answer= {
                  value: formatMessage('tTime'),
                  is_true: -1
                };
              }
              if(i_a.is_true)
                students[index].answer_count +=1; 
              return true;
            }
          })

          tmp_data.answers.push(answer);
        });


        if(tmp_data.answers.length){
          let count_true =  tmp_data.answers.filter(i => i.is_true).length; 

          tmp_data.answers.push({value: (100/tmp_data.answers.length * count_true).toFixed(2) + '%', is_true: null})
        } else {
          tmp_data.answers.push({value: '0%', is_true: null})
        }

        
      
        data.push(tmp_data)
      }

    });
    

    return (
      <div className="AnswerStatistic">
        <div style={{position: 'relative', minHeight: 300}}>
          {!loaded && 
          <div style={{position: 'absolute', zIndex: 9, width: '100%', height: '100%', background: 'rgba(255,255,255, 0.4)'}}>
            <Spiner />
          </div>
          }
          {(data.length > 0 && loaded) && <div style={{display: 'flex'}}>
              <div className="student-check-name"><Switch checked={show_student_name} onChange={() => this.setState({show_student_name: !show_student_name})} />{formatMessage("labelStudentShowName")}</div>
              <a href="#" onClick={this.dowloadStatistic} style={{fontSize: 19, marginLeft: 10}}><i className="fas fa-download"></i></a>
          </div>}
          {(data.length > 0 && loaded) && <div className="table-stat">
              <div className="student-items">
                <div className="st-item">
                  {formatMessage("labelStudentsSt")}
                </div>
                {students.map((item, index) => 
                  <div className="st-item" key={'st-' + item.id}>
                    <span>{show_student_name ? item.student_name || formatMessage("labelStudentNotName") : formatMessage("labelStudentSt") + ' ' + (index + 1)}</span> <span style={{marginLeft: 10}}>{(100/data.length*item.answer_count).toFixed(2)}%</span>
                  </div>
                )}
                <div className="st-item">
                  {formatMessage("labelTotalSt")}
                </div>
              </div>
              <div className="q-items">
                {data.map((item, index) => <div key={'question-' + item.question.id} className="q-cols">
                    <div className="q-item q-title">{formatMessage("QuestionTxt")} #{item.number}</div>
                    {item.answers.map(answer => <div className={classNames("q-item", {
                      'correct': answer.is_true == true,
                      'not-correct': answer.is_true == false,
                      'time': answer.is_true == -1,
                    })}>{answer.value}</div>)}
                  </div>
                )}
              </div>
          </div>}
        </div>
        
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  sessions: state.presentation.sessions,
  questions: state.presentation.items,
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(AnswerStatistic);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentation/components/Slide/components/AnswerStatistic/index.jsx